// extracted by mini-css-extract-plugin
export default {"modal":"CurrencyModal_modal__z227C","content":"CurrencyModal_content__1jKYD","input":"CurrencyModal_input__d1aD4","btnWrapper":"CurrencyModal_btnWrapper__0SVZv"};